import React from 'react';
import { FormattedMessage } from 'react-intl';

import Button from 'carbon-react/lib/components/button';
import { RenderOpenProps } from 'carbon-react/lib/components/popover-container';

import { PopoverMenu, PopoverMenuItem } from '../../../popover-menu/popover-menu';

export type ListingPageRowActionItem = PopoverMenuItem;

interface ListingPageRowActionsProps {
  items: ListingPageRowActionItem[];
}

export const ListingPageRowActions = ({ items }: ListingPageRowActionsProps) => {
  return (
    <PopoverMenu
      items={items}
      renderOpenComponent={({ onClick, ref, 'aria-expanded': ariaExpanded }: RenderOpenProps) => (
        <Button
          buttonType="tertiary"
          iconType="ellipsis_vertical"
          iconPosition="after"
          onClick={onClick}
          ref={ref}
          aria-expanded={ariaExpanded}
        >
          <FormattedMessage id="predict.actions" defaultMessage="Actions" />
        </Button>
      )}
    />
  );
};
